import React, { useState } from 'react';
import { post } from '../common/axiosClient';
import { API } from '../common/constants/urls';

const DivisionUpload: React.FC = () => {
  const [files, setFiles] = useState<FileList | null>(null);

  const onFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.files && event.target.files.length > 0) {
      setFiles(event.target.files);
    }
  };

  const onUploadFile = async (endpoint: string, formData: FormData, i: number, fileName: string) => {
    try {
      const response = await post(API.UPLOAD_DIVISION, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
      // alert(response.message);
      console.log(response.message + ' :: ' + i + ' :: ' + fileName);
    } catch (error: any) {
      // alert('Error uploading the file.' + error.message);
      console.log('Error uploading the file.' + error.message + ' :: ' + i + ' :: ' + fileName);
    }
  };

  const onUploadClick = async (endpoint: string) => {
    if (!files) {
      alert('Please select a file.');
      return;
    }

    for (let i = 0; i < files.length; i++) {
      const file = files[i];
      const formData = new FormData();
      formData.append('file', file);
      try {
        const response = await onUploadFile(endpoint, formData, i, file.name);
      } catch (error) {
        // break;
      }
    }
  };

  return (
    <div>
      <input type='file' multiple onChange={onFileChange} />
      <button onClick={() => onUploadClick('upload-divisions')}>Upload Divisions</button>
    </div>
  );
};

export default DivisionUpload;
